(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.mpLogoGrid = {
    attach: function (context, settings) {
      if (typeof settings.mp_paragraphs === 'undefined') return;
      for (var id in settings.mp_paragraphs.mp_logo_grid) {
        var logo_grid_settings = settings.mp_paragraphs.mp_logo_grid[id];

        $.each(logo_grid_settings.ids, function(i, id) {
          var $slider = $('#' + id + ' > .mp-logo-grid-slider__slides', context),
            $paginationLabel = $slider.siblings('.mp-logo-grid-slider__pagination-label'),
            $sliderItems = $slider.find('.mp-logo-grid-item'),
            sliderItemCount = $sliderItems.length
          ;

          if ($slider.length === 0) return;

          // Always true!
          // if (logo_grid_settings.enable_arrows) {
            $slider.addClass('slick-arrowed');
          // }


          // $slider
          $(once('slick', $slider, context))
            .on('init', function(slick) {
              toggleHasArrowsClass();
              setLabel(0);
            })
            .on('breakpoint', function(event, slick) {
              toggleHasArrowsClass();
            })
            .on('afterChange', function(event, slick, currentSlide, nextSlide) {
              setLabel(currentSlide);
            })
            .slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
              infinite: true
            })
          ;

          function toggleHasArrowsClass() {
            $slider.toggleClass('slick-has-arrows', $slider.find('.slick-prev').length ? true : false);
          }

          // setLabel(0);

          function setLabel(currentSlide) {
            var $slides = $slider.find('.mp-logo-grid-slider__slide'),
                $currentSlide = $($slides.get(currentSlide + 1)),
                $currentSlideItems = $currentSlide.find('.mp-logo-grid-item'),
                first = $sliderItems.index($currentSlideItems.first()) + 1,
                last = $sliderItems.index($currentSlideItems.last()) + 1
            ;

            const label = `${first}-${last} of ${sliderItemCount}`;

            $paginationLabel.html(label);
          }

        });

      }
    }
  };

})(jQuery, Drupal, drupalSettings);
